// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"22c05e10033c806d7b71","589":"3901077176c86dc88356","691":"62994afafd32fffb1927"}[chunkId] + ".js";
};